/**
 * Global shortcut registry. Keys are lowercase KeyboardEvent.key values
 * (" " for Space, "escape" for Esc). Returns a detach function.
 */
type ShortcutHandler = (e: KeyboardEvent) => void;

function isFormTarget(el: Element | null): boolean {
  return (
    el instanceof HTMLInputElement || // includes focused range sliders
    el instanceof HTMLSelectElement ||
    el instanceof HTMLTextAreaElement ||
    (el instanceof HTMLElement && el.isContentEditable)
  );
}

export function attachShortcuts(map: Record<string, ShortcutHandler>): () => void {
  const onKeydown = (e: KeyboardEvent) => {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    const key = e.key.toLowerCase();
    const handler = map[key];
    if (!handler) return;
    const active = document.activeElement;
    // Focus guard: never steal keys from form controls (except Esc).
    if (key !== "escape" && isFormTarget(active)) return;
    // Space on a focused button should activate the button, not the shortcut.
    if (key === " " && active instanceof HTMLButtonElement) return;
    e.preventDefault();
    handler(e);
  };
  window.addEventListener("keydown", onKeydown);
  return () => window.removeEventListener("keydown", onKeydown);
}
